// This file was automatically generated from app.shared.dialog.addEditDocTag.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.shared.dialog.addEditDocTag');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.addEditDocTag.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="add-edit-doctag-form" class="el8DialogContainer ebs-form-horizontal"><div class="el8FieldSection ebs-form-group"><label class="el8FieldLong el8FieldRequired ebs-control-label ebs-col-sm-2"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>Label:</span></label><div class="el8FieldLongLabelPadding el8TextareaWrap ebs-col-sm-10"><input type="text" class="doctag-value w100 ebs-form-control" name="value"></input></div></div><div class="el8FieldSection ebs-form-group"><label class="el8FieldLong ebs-control-label ebs-col-sm-2">Description:</label><div class="el8FieldLongLabelPadding el8TextareaWrap ebs-col-sm-10"><input type="text" class="doctag-description w100 ebs-form-control" name="description"></input></div></div><div class="el8FieldSection ebs-form-group"><label class="el8FieldLong ebs-control-label ebs-col-sm-2">Code:</label><div class="el8FieldLongLabelPadding ebs-col-sm-10"><select class="doctag-codetype w25 ebs-col-xs-3 padh0" name="codeType"><option value="">--</option>');
  var codeTypeList7939 = opt_data.codeTypeChoices;
  var codeTypeListLen7939 = codeTypeList7939.length;
  for (var codeTypeIndex7939 = 0; codeTypeIndex7939 < codeTypeListLen7939; codeTypeIndex7939++) {
    var codeTypeData7939 = codeTypeList7939[codeTypeIndex7939];
    output.append('<option value="', soy.$$escapeHtml(codeTypeData7939), '">', soy.$$escapeHtml(codeTypeData7939), '</option>');
  }
  output.append('</select><input type="text" class="doctag-code w70 el8TextareaWrapLessMargin ebs-form-control ebs-col-xs-9 ml5" name="code"></input></div></div></form>');
  if (!opt_sb) return output.toString();
};
